import { render } from "./EcommerceWordpress.vue?vue&type=template&id=5ee79712&scoped=true"
import script from "./EcommerceWordpress.vue?vue&type=script&lang=js"
export * from "./EcommerceWordpress.vue?vue&type=script&lang=js"

import "./EcommerceWordpress.vue?vue&type=style&index=0&id=5ee79712&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee79712"]])

export default __exports__